<template>
  <div>
    <a-drawer
      title="基本信息"
      placement="right"
      width="500"
      :closable="false"
      @close="onClose"
      :visible="visible"
    >
      <a-form :form="form" @submit="saveColumnData">
        <a-form-item
          label="关联角色"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'role_id',
              {
                rules: [{ required: true, message: '请选择所属角色' }]
              }
            ]"
            placeholder="请选择所属角色">
            <a-select-option v-for="item in roleDict" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="账号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'account',
              {
                rules: [{ required: true, message: '请输入管理员账号' }]
              }
            ]"
            placeholder="请输入管理员账号"/>
        </a-form-item>
        <a-form-item
          label="联系人名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'nickname',
              {
                rules: [{ required: true, message: '请输入联系人名称' }]
              }
            ]"
            placeholder="请输入管理员昵称"/>
        </a-form-item>
        <a-form-item
          label="联系人电话"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'phone',
              {
                rules: [{ required: true, message: '请输入联系人电话' }]
              }
            ]"
            placeholder="请输入联系人电话"/>
        </a-form-item>
        <a-form-item
          label="密码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <span>由系统自动生成 123456 初始密码</span>
        </a-form-item>
        <a-form-item
          :required="true"
          label="状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group v-model="addData.status">
            <a-radio-button v-if="status.id !== ''" v-for="status in statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            v-decorator="[
              'remark',
              {
                rules: [{ required: true, message: '请输入备注' }]
              }
            ]"
            :rows="6"
            placeholder="请输入备注"/>
        </a-form-item>
        <a-form-item :wrapperCol="{span: 12, offset: 9}">
          <a-button style="margin-right:20px" html-type="submit" type="primary" :loading="loading">创建</a-button>
          <a-button @click="onClose">取消</a-button>
        </a-form-item>
      </a-form>
    </a-drawer>
  </div>
</template>
<script>
import { pre, postAdminBasicInfo } from '@/api/admin'
import _ from 'lodash'
export default {
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.handelPre()
  },
  data () {
    return {
      form: this.$form.createForm(this),
      // 编辑抽屉弹窗form-item标题样式
      labelCol: { lg: { span: 6 }, sm: { span: 5 } },
      // 编辑抽屉弹窗form-item组件样式
      wrapperCol: { lg: { span: 15 }, sm: { span: 19 } },
      // 按钮加载
      loading: false,
      // 添加数据
      addData: {
        account: '',
        password: '',
        nickname: '',
        realname: '',
        phone: '',
        role_id: '',
        status: 'NORMAL',
        remark: ''
      },
      roleDict: [],
      statusDict: []
    }
  },
  methods: {
    handelPre () {
      pre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.roleDict = _.get(res, 'values.roleDict', [])
          this.statusDict = _.get(res, 'values.statusDict', [])
        }
      })
    },
    // 抽屉关闭事件
    onClose () {
      this.$emit('hide')
    },
    // 抽屉保存按钮
    saveColumnData (e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((err, fieldsValue) => {
        if (!err) {
          this.addData.role_id = fieldsValue['role_id']
          this.addData.account = fieldsValue['account']
          this.addData.nickname = fieldsValue['nickname']
          this.addData.realname = fieldsValue['realname']
          this.addData.phone = fieldsValue['phone']
          this.addData.remark = fieldsValue['remark']
          postAdminBasicInfo(this.addData).then(res => {
            if (_.get(res, 'code') === 200) {
              this.loading = false
              this.$message.success('添加管理员成功')
              setTimeout(() => { this.$emit('finish') }, '500')
            } else this.loading = false
          })
        } else this.loading = false
      })
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  }
}
</script>
